import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiEndpoints } from '../../constants/api';
import axios from 'axios';
import {
  PostQuarterlyRevenueStatusDto,
  PutQuarterlyRevenueStatusDto,
} from '../../types/quarterlyRevenue';
import { quarterlyRevenueSlice } from './quarterlyRevenue.slice';
import { notificationAlert } from '../notifications';
import { formatErrorMessage } from '../../utils';
import { GetRevenuePagePayloadType } from '../../types/quarterlyRevenue';

export const getQuarterlyRevenueAccount = createAsyncThunk(
  `/getQuarterlyRevenueAccount`,
  async (pagePayload: GetRevenuePagePayloadType, thunkAPI) => {
    try {
      const response = await axios.post(
        apiEndpoints.getQuarterlyRevenueAccount(),
        pagePayload,
      );

      return {
        accounts: response.data.quarterlyRevenueStatuses,
        totalPages: response.data.totalPages,
      };
    } catch (err) {
      thunkAPI.dispatch(quarterlyRevenueSlice.actions.clearAccount());
      throw new Error(String(err));
    }
  },
);

export const updateQuarterlyRevenueSummary = createAsyncThunk(
  `/updateQuarterlyRevenueSummary`,
  async (quarterlySummary: PutQuarterlyRevenueStatusDto, thunkAPI) => {
    try {
      const response = await axios.post(
        apiEndpoints.createQuarterlyRevenueSummary(),
        quarterlySummary,
      );

      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );
      throw new Error(String(err));
    }
  },
);

export const editQuarterlyRevenueSummary = createAsyncThunk(
  `/editQuarterlyRevenueSummary`,
  async (quarterlySummary: PostQuarterlyRevenueStatusDto, thunkAPI) => {
    try {
      const response = await axios.patch(
        apiEndpoints.editQuarterlyRevenueSummary(),
        quarterlySummary,
      );

      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );
      throw new Error(String(err));
    }
  },
);

export const getQuarterlyRevenueById = createAsyncThunk(
  `getQuarterlyRevenueById`,
  async (accountId: string, thunkAPI) => {
    try {
      const response = await axios.get(
        apiEndpoints.quarterlyRevenueById(accountId),
      );
      return response.data;
    } catch (err) {
      thunkAPI.dispatch(quarterlyRevenueSlice.actions.cleanAccountsList());
      throw new Error(String(err));
    }
  },
);

export const exportQuarterlyRevenueData = createAsyncThunk(
  `exportQuarterlyRevenueData`,
  async (quarter: number | undefined, thunkAPI) => {
    try {
      const payload = quarter ? { quarter } : {};
      const response = await axios.post(
        apiEndpoints.exportQuarterlyRevenue(),
        payload,
      );
      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );
      throw new Error(String(err));
    }
  },
);
